import React from 'react';
import ExitWarningModal from '|/components/verifx/components/ExitWarningModal';
import type { useNavigationRailVm } from '../../hooks/use-navigation-rail-vm';
import { CancelOrderModal, EditOrderModal as EditOrderModalDS } from './index';

interface NavRailModalsProps {
  vm: ReturnType<typeof useNavigationRailVm>;
}

/**
 * Rendered as a sibling of the rail rather than inside it. On mobile the rail lives inside the
 * drawer's EventedModal, and ds-modal returns null when closed — so a modal owned by the rail is
 * unmounted by the very click that opens it, and the link does nothing (TXCC-10041). Keeping these
 * above the drawer lets onNavigate() close it without taking the modal down.
 */
const NavRailModals: React.FC<NavRailModalsProps> = ({ vm }) => {
  const {
    deliveryType,
    latestStep,
    isEditOrderModalDSShown,
    isCancelOrderModalDSShown,
    isKiqExitWarningModalNavRailShown,
    editingSectionName,
    targetStep,
    handleModalClose,
    handleKiqLeave
  } = vm;

  return (
    <>
      <CancelOrderModal
        isOpen={isCancelOrderModalDSShown}
        onClose={() => {
          handleModalClose('cancel');
        }}
      />

      <EditOrderModalDS
        isOpen={isEditOrderModalDSShown}
        onClose={() => {
          handleModalClose('edit');
        }}
        deliveryPreference={deliveryType}
        editingSectionName={editingSectionName}
        targetStep={targetStep}
        currentSectionName={latestStep?.sectionName}
      />

      <ExitWarningModal
        isOpen={isKiqExitWarningModalNavRailShown}
        fromNavRail={true}
        outOfAttempts={false}
        onLeave={handleKiqLeave}
        onClose={() => {
          handleModalClose('kiq');
        }}
      />
    </>
  );
};

export default NavRailModals;
